<template>
  <v-menu v-model="userMenu" left :offset-y="true" transition="slide-y-transition"> <!-- fade-up -->
    <template v-slot:activator="{}">
        <div @click.stop="userMenu = !userMenu">
            <avatar class="e-link" v-ripple color="grey darken-2" :size="42" :icon-size="42" :src="avatar"/>
        </div>
    </template>
    <v-list min-width="180" >
        <!-- <v-list-item >
            <div>
                أهلا <span class="primary--text text--darken-2">{{name.split(' ')[0]}}</span>
            </div>
        </v-list-item>
        <v-divider class="mb-3" /> -->
        <v-list-item  @click="$router.push({name: 'settings'}); userMenu = false" disabled>
            <v-list-item-title>الإعدادات</v-list-item-title>
        </v-list-item>
        <v-list-item link @click="logoutDialog = true; userMenu = false">
            <v-list-item-title>تسجيل الخروج</v-list-item-title>
        </v-list-item>
    </v-list>

    <logout-dialog v-model="logoutDialog" />
</v-menu>
</template>

<script>
import Avatar from '../../default/avatar'
import LogoutDialog from '../../default/dialogs/logout'

export default {
    props: ['name', 'avatar'],
    data(){
        return {
            userMenu: false,
            logoutDialog: false,
        }
    },
    components: {Avatar, LogoutDialog},
}
</script>

<style>

</style>